var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPaymentAdvanced = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.34174 0.0602085C8.06551 -0.0402411 7.75907 -0.0140729 7.50386 0.131759L0.503861 4.13176C0.192286 4.3098 0 4.64114 0 5V15C0 15.4205 0.263068 15.7961 0.658257 15.9398L11.6583 19.9398C11.9345 20.0402 12.2409 20.0141 12.4961 19.8682L19.4961 15.8682C19.8077 15.6902 20 15.3589 20 15V5C20 4.5795 19.7369 4.20391 19.3417 4.06021L8.34174 0.0602085ZM18 11.7232L12.4961 14.8682C12.2409 15.0141 11.9345 15.0402 11.6583 14.9398L2 11.4277V14.2996L11.9062 17.9018L18 14.4197V11.7232ZM3.36969 4.79764L8.09378 2.09817L16.6303 5.20236L11.9062 7.90184L3.36969 4.79764ZM12.4961 9.86825L18 6.72318V9.41968L11.9062 12.9018L2 9.29957V6.4277L11.6583 9.9398C11.9345 10.0402 12.2409 10.0141 12.4961 9.86825Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPaymentAdvanced);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/payment-advanced.e0d513b47fbff1a093d6899dfeb0b1bd.svg";